import React from "react";
import SubHeader from "../general/SubHeader";
import AboutMe from "../general/AboutMe";
import BioFuel1 from "../../assets/bio-fuel1.jpeg";
import BioFuel2 from "../../assets/bio-fuel2.jpeg";
import EventMgt1 from "../../assets/event-mgt1.jpeg";
import EventMgt2 from "../../assets/event-mgt2.jpeg";
import RealEstate1 from "../../assets/real-estate1.jpeg";
import RealEstate2 from "../../assets/real-estate2.jpeg";

const About = () => {
  return (
    <>
      <SubHeader message="About Us" />
      <AboutMe />

      {/* Our history section */}
      <section className="my-5">
        <div className="container text-center">
          <div className="sec-subheading">
            <hr />
            <span>We deal in</span>
            <hr />
          </div>
          {/* <p className='sec-heading'>Our specialization</p> */}
          <p className="mt-4 text-muted">
            Swalok Group specializes in a wide range of services, including fund
            management activities and the management of other investment funds.
            We offer real estate services, both with own or leased property and
            on a fee or contract basis. Our management consultancy services
            provide businesses with valuable insights, helping them optimize
            their operations and achieve sustainable success.
            <br />
            We also lead in advertising and market research, offering innovative
            strategies to enhance brand visibility and support informed
            decision-making. In addition, our employment activities focus on
            placement services, connecting top talent with the right
            opportunities. Finally, we provide comprehensive office
            administrative, support, and other business support services to
            ensure seamless business operations. Swalok Group is your trusted
            partner for growth, efficiency, and success across industries.
          </p>
        </div>
      </section>
      {/* Our history section ends */}

      {/* Our mission section */}
      <section className="my-5">
        <div className="container text-center px-4">
          <div className="sec-subheading">
            <hr />
            <span>Values</span>
            <hr />
          </div>
          <p className="sec-heading">Our Mission Focus</p>

          <div className="row mt-5">
            <div className="col-lg-6 col-12 my-3">
              <div className="mission-area">
                <div className="col-lg-6 col-md-5">
                  <img src={RealEstate1} className="img-fluid" alt="Mission" />
                  <img src={RealEstate2} className="img-fluid" alt="Mission" />
                </div>
                <div className="mission-info">
                  <p className="fs-5 fw-bold fst-italic">Real Estate</p>
                  <hr />
                  <p className="text-muted">
                    Our mission is to provide high-quality, strategically
                    located properties that offer exceptional value, creating
                    lasting investments and communities for future generations.
                  </p>
                  <i className="fa-solid fa-building mission-icon"></i>
                </div>
                {/* mission info ends */}
              </div>
            </div>

            <div className="col-lg-6 col-12 my-3">
              <div className="mission-area">
                <div className="col-lg-6 col-md-5">
                  <img src={EventMgt1} className="img-fluid" alt="Mission" />
                  <img src={EventMgt2} className="img-fluid" alt="Mission" />
                </div>
                <div className="mission-info">
                  <p className="fs-5 fw-bold fst-italic">Event Management</p>
                  <hr />
                  <p className="text-muted">
                    We strive to craft unforgettable events by blending
                    creativity, precision, and seamless coordination, ensuring
                    each experience exceeds expectations and leaves a lasting
                    impact.
                  </p>
                  <i className="fa-solid fa-building mission-icon"></i>
                </div>
                {/* mission info ends */}
              </div>
            </div>

            <div className="col-lg-6 col-12 my-3">
              <div className="mission-area">
                <div className="col-lg-6 col-md-5">
                  <img src={BioFuel1} className="img-fluid" alt="Mission" />
                  <img src={BioFuel2} className="img-fluid" alt="Mission" />
                </div>
                <div className="mission-info">
                  <p className="fs-5 fw-bold fst-italic">Bio Fuel</p>
                  <hr />
                  <p className="text-muted">
                    Our mission is to promote sustainability by developing
                    innovative biofuel solutions, reducing carbon footprints,
                    and contributing to a cleaner, greener energy future for
                    all.
                  </p>
                  <i className="fa-solid fa-building mission-icon"></i>
                </div>
                {/* mission info ends */}
              </div>
            </div>
          </div>
          {/* row ends */}
        </div>
      </section>
      {/* Our mission section ends */}
    </>
  );
};

export default About;
